export const CalendarQuickFilters = {
    last30Days: 'last30Days',
    last3Months: 'last3Months',
    currentYear: 'currentYear',
    customRange: 'customRange',
};
export const CalendarCurrentSelection = {
    Start: 'start',
    End: 'end',
};